import React from "react";
import "./App.css";

import AppStore from "./store/App";
import ManpowerAssociate from "./App/index";

import moment from "moment-timezone";

const App = () => {
  return (
    <AppStore>
      <ManpowerAssociate />
    </AppStore>
  );
};

export default App;
